import Tools from '../../../../base/components/tools';

/******************** BUILD ********************/
import less from '../index.less';
/******************** BUILD ********************/

class CarruselVertical extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      configurations: {},
      data: [],
      cantImages: 3
    };
    this.page = _spPageContextInfo.webTitle == 'Servicios Premium'? 'Premium Individual': 'Premium Empresa';
    this.pnpService = new ServicioPnp();
    this.tools = new Tools();
    this.hideDiv  = this.hideDiv.bind(this);
    this.setConfiguraciones = this.setConfiguraciones.bind(this);
    this.setCarruselData = this.setCarruselData.bind(this);
    this.carouselSettings = {
        //centerMode: true,
        centerPadding: '10px',
        infinite: true,
        speed: 500,
        vertical: true,
        verticalSwiping: true,
        swipeToSlide: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplaySpeed: 3000,
    }
  }

  componentDidMount() {
    this.setConfiguraciones();
    //(this.setCarruselData();
    const verticalCarousel = $('#vertical-carousel');
    const settings = { 
      ...this.carouselSettings,
      autoplay: this.state.data.length <= 3 ? false : true,
      arrows: this.state.data.length <= 3 ? false : true,
      slidesToShow: this.state.data.length >= 3? 3: this.state.data.length,
      autoplaySpeed: this.state.configurations['CarruselVerticalTiempoTransicion'] ? (parseInt(this.state.configurations['CarruselVerticalTiempoTransicion']) * 1000) : 3000,
    }
    verticalCarousel.slick(settings);
  }

  componentDidUpdate() {
    const verticalCarousel = $('#vertical-carousel');
    try {
      verticalCarousel.slick('unslick');
    } catch(e) {}
    const settings = { 
      ...this.carouselSettings,
      autoplay: this.state.data.length <= 3 ? false : true,
      arrows: this.state.data.length <= 3 ? false : true,
      slidesToShow: this.state.data.length >= 3? 3: this.state.data.length,
      autoplaySpeed: this.state.configurations['CarruselVerticalTiempoTransicion'] ? (parseInt(this.state.configurations['CarruselVerticalTiempoTransicion']) * 1000) : 3000,
    }
    verticalCarousel.slick(settings);
  }

  hideDiv() {
    $(this.refs['container-div']).addClass('hidden');
    const thiscol = $(this.refs['container-div']).closest('.home-component-container');
    const othercol = $(this.refs['container-div']).closest('.row').find('.home-component-container').not(thiscol);
    if((thiscol[0] && othercol[0]) && (thiscol.find('.home-component').length == thiscol.find('.home-component.hidden').length)) {
      thiscol.addClass('hidden');
      othercol.removeClass('col-sm-5').removeClass('col-sm-6').removeClass('col-sm-7').addClass('col-sm-12');
    }
  }

  setConfiguraciones() {
    const configurations = {};
    this.pnpService.getList('configuraciones', (list) => {
      list.forEach((item) => {
        configurations[item.CSNombreText] = item.CSValorNote;
      });

      this.pnpService.getList('parametrosPaginas', (list) => {
        list.forEach((item) => {
          configurations[item.CSNombreText] = item.CSValorNote == 'false' ? false : item.CSValorNote;
          configurations[item.CSNombreText + 'CSVisibleBool'] = item.CSVisibleBool;
        });

        if (configurations['CarruselVerticalCSVisibleBool']) {
          this.setState({ configurations });
          this.setCarruselData();
        } else {
          this.hideDiv();
        }

      }, `(CSFormularioChoice eq '${this.page}')`);

    }, "CSNombreText eq 'MensajeErrorDeServicios' or CSNombreText eq 'MensajeNegacionDeServicio' or CSNombreText eq 'CarruselServiciosTiempoTransicion'", 'CSNombreText', 'CSValorNote');
  }

  setCarruselData() {
    const page = _spPageContextInfo.webTitle == 'Servicios Premium'? 'Premium Individual': 'Premium Empresa';
    const url = `ObtenerCarruselVertical?home=${page}`;
    const getCarruselData = new ServicioProxy(url, 'ServicioConsorcioHomesPremium.svc');
    getCarruselData.getElements('POST', {}).then((response) => {
      const data = JSON.parse(response);
      if (data.length) {
        this.setState({ data });
      } else {
        this.hideDiv();
      }
    }).catch(error => {
      this.hideDiv();
      console.error(error);
    });
  }

  render() {
    return (
      <div className="home-component vertical-carousel-container hide-on-message" ref="container-div">
        { this.state.configurations['CarruselVerticalCSVisibleBool'] && 
        (<div className="vertical-carousel-container">
          <h2 className="text-center carousel-title">{this.state.configurations['CarruselVerticalTitulo']}</h2>
          <div className="border-dotted-top"></div>

          <div className="container-vc">
            <div>
              <div className={this.state.data.length >= 3? "carousel-gradient gradient-top": ""}></div>
              <div className={this.state.data.length >= 3? "carousel-gradient gradient-bottom": ""}></div>
            </div>
            <div id="vertical-carousel">
              { this.state.data.map((item, index) => { 
                const image = item.Imagen.match(/.*src="(.*)".*style:*/)[1];
                return (
                  <div className="carousel-item row">
                    <div className="col-md-5">
                      <div className="container-img">
                        <img className="vertical-carousel-img" src={image} />
                      </div>
                    </div>
                    <div className="carousel-text col-md-7">
                      <h3>{item.Titulo}</h3>
                      <p className="carousel-item-description">{item.Descripcion}</p>
                    </div>
                  </div>
                );
              }) }
            </div>
          </div>

        </div>) }
      </div>
    );
  }
}

const appId = document.getElementById('carruselVertical');
ReactDOM.render(<CarruselVertical />, appId);


// WEBPACK FOOTER //
// ./home/components/carruselvertical/src/index.js